import React from 'react'

const SvgSproutFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M8.715 6.225C7.247 5.425 5.423 5 3.239 5a1 1 0 00-.983.815c-.528 2.807-.48 6.146 2.593 8.332 1.909 1.358 3.929 1.748 6.053 1.833.064.324.098.664.098 1.02v3H3a1 1 0 100 2h18a1 1 0 000-2h-8v-3c0-1.114.206-2.13.545-3.047 1.976-.136 3.863-.612 5.646-2.021 1.47-1.162 2.271-2.526 2.61-4.1.328-1.526.208-3.2-.05-4.976A1 1 0 0020.76 2c-2.201 0-4.04.478-5.515 1.37-.53.32-1.007.692-1.434 1.107-1.039 1.01-1.733 2.428-2.17 3.905-.05.167-.096.335-.139.505a6.749 6.749 0 00-1.353-1.665 7.93 7.93 0 00-1.435-.997z' />
    <path d='M6 9c1.5.5 2.5 1.5 3.5 3m9-6c-2 .5-3.5 2-4 4.5' strokeWidth={2} strokeLinecap='round' />
  </svg>
)

export default SvgSproutFilled
